import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon } from 'lucide-react';
const bonuses = [{
  n: '01',
  title: 'Calculadora "Inflación-Proof" de Costos',
  desc: 'Planilla automatizada donde cargás tela, taller y packaging y te devuelve el precio de venta exacto con margen real, considerando inflación, impuestos, comisiones y publicidad en Argentina.',
  price: '$14.990'
}, {
  n: '02',
  title: 'Filtro de Oro para Proveedores',
  desc: 'Las 15 preguntas clave que debés hacerle a cualquier taller o mayorista antes de transferir un peso. Si no pasan este filtro, no son para vos. Evitá estafas desde el primer contacto.',
  price: '$9.990'
}, {
  n: '03',
  title: 'Reporte 2026: 30 Nichos con Hambre de Compra',
  desc: 'Investigamos por vos. 30 micro-nichos de ropa con alta demanda en redes y baja competencia profesional. Ya sabés exactamente qué vender antes de invertir un solo peso.',
  price: '$7.990'
}, {
  n: '04',
  title: 'Scripts de Venta "Cierre Inmediato" (WhatsApp & DM)',
  desc: 'Los guiones exactos para responder el "¿Precio?", manejar objeciones de envío y transformar un "me interesa" en una notificación de "Venta Realizada" sin sonar desesperado ni insistente.',
  price: '$7.990'
}, {
  n: '05',
  title: 'Radar Viral de Reels y TikTok',
  desc: '20 estructuras de video que funcionan para marcas de ropa. Sabé qué filmar cada día para que tus prendas lleguen a miles de personas sin pagar anuncios ni contratar community managers.',
  price: '$5.990'
}];
export function Bonuses() {
  return <section aria-label="Bonos" className="border-y border-white/5 bg-ink-2" data-id="element-14" data-mp="38gijagcrga88">
      <div className="mx-auto max-w-5xl px-5 pb-[22px]" data-id="element-15" data-mp="33hfe8vws6409">
        <h2 className="pt-[28px] text-center font-display text-2xl font-black text-white sm:text-4xl" data-id="element-16" data-mp="33ful9aq46t4i">
          🎁 5 Bonos estratégicos — siempre incluidos
        </h2>

        <div className="mt-12 grid gap-5 sm:grid-cols-2" data-id="element-17" data-mp="ipwvhbcumc39">
          {bonuses.map((b, i) => <motion.div key={b.n} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.4,
          delay: i % 2 * 0.08
        }} className="relative flex flex-col rounded-2xl border border-gold/25 bg-ink p-6" data-id="element-18" data-mp="3chv4tp2jtam4" data-mpi={i}>
              <div className="mb-3 flex flex-wrap items-center justify-between gap-2" data-id="element-19" data-mp="2tsyjwbt1jugk">
                <span className="inline-flex items-center gap-1.5 rounded-full bg-gold/15 px-3 py-1 text-xs font-bold text-gold" data-id="element-20" data-mp="2xtqv3alh49fh">
                  <GiftIcon className="h-3.5 w-3.5" data-id="element-21" data-mp="32s245j3y2fwn" /> Bono {b.n}
                </span>
                <span className="text-sm font-bold" data-id="element-22" data-mp="37k3cwv1wlohx">
                  <span className="text-white/40 line-through" data-id="element-23" data-mp="37lwlwgzzokt3">{b.price}</span>{' '}
                  <span className="text-celeste" data-id="element-24" data-mp="2a45xpmokp9mo">GRATIS</span>
                </span>
              </div>
              <h3 className="text-base font-bold text-white" data-id="element-25" data-mp="2f1pplpe71kx3">{b.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-white/60" data-id="element-26" data-mp="27iorxkq2qlhn">{b.desc}</p>
            </motion.div>)}
        </div>

        <div className="mt-10 rounded-2xl border border-celeste/40 bg-celeste/10 p-6 text-center" data-id="element-27" data-mp="22ityb9ewzhsw">
          <p className="text-base font-bold text-white sm:text-lg" data-id="element-28" data-mp="1xnwt6dkr9sla">
            Valor total de los bonos: <span className="text-white/50 line-through" data-id="element-29" data-mp="1tmbaucpgcm3p">$46.950</span>{' '}
            <span className="text-[15px] text-gold" data-id="element-30" data-mp="1omqabxumw5ov">HOY GRATIS CON TU MASTERPACK</span>
          </p>
        </div>
      </div>
    </section>;
}